<template>
  <v-layout row wrap>
    <slot></slot>
  </v-layout>
</template>
<script>
export default {};
</script>
